import { render, staticRenderFns } from "./FormatoQTT.vue?vue&type=template&id=7abe2c71&"
import script from "./FormatoQTT.vue?vue&type=script&lang=js&"
export * from "./FormatoQTT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports